interface Props {
  label: string;
  value: string | number;
  sub: string;
  colorClass: string;
}
export function MetricCard({
  label,
  value,
  sub,
  colorClass
}: Props) {
  return <div className="mc" data-id="element-267">
      <div className="ml" data-id="element-268">{label}</div>
      <div className={`mv ${colorClass}`} data-id="element-269">{value}</div>
      <div className="ms" data-id="element-270">{sub}</div>
    </div>;
}